import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { Reason } from '../../core/model/central/reason.model';
import { STORE_FEATURE_KEY_REASONS } from './reasons-settings.reducer';

const loadingIndicatorSelector = (appState: any) => appState[STORE_FEATURE_KEY_REASONS].loadingIndicator;
const reasonsSelector = (appState: any) => appState[STORE_FEATURE_KEY_REASONS].reasons;
const strategyIdSelector = (appState: any) => appState[STORE_FEATURE_KEY_REASONS].strategyId;
const selectedReasonSelector = (appState: any) => appState[STORE_FEATURE_KEY_REASONS].selectedReason;
const revertChangesSelector = (appState: any) => appState[STORE_FEATURE_KEY_REASONS].revertChanges;

@Injectable({
  providedIn: "root"
})
export class ReasonsSettingsSelectors {
    constructor(private store: Store<any>) {
    }

    selectReasons(): Observable<Array<Reason>> {
        return this.store
            .pipe(select(reasonsSelector));
    }

    selectSelectedReason(): Observable<Reason> {
        return this.store
            .pipe(select(selectedReasonSelector));
    }

    selectStrategyId(): Observable<number> {
        return this.store
            .pipe(select(strategyIdSelector));
    }

    selectLoadingIndicatorStatus(): Observable<boolean> {
        return this.store.pipe(select(loadingIndicatorSelector));
    }

    selectRevertChanges(): Observable<boolean> {
        return this.store.pipe(select(revertChangesSelector));
    }
}
